import type { AssetListItem } from '@cartwhl/common/api/getAssets';

import AssetLibraryThumbnail from './AssetLibraryThumbnail';

const STACK_LAYER_COUNT = 4;
const STACK_OFFSET_PX = 4;
const STACK_LAYER_CLASS =
  'absolute top-0 left-0 h-full w-full overflow-hidden rounded-lg border-r-2 border-r-white dark:border-r-gray-90';

export interface AssetLibraryStackedThumbnailProps {
  asset: AssetListItem;
  isHovered?: boolean;
  autoPlayVideo?: boolean;
  onLoadError?: () => void;
}

export default function AssetLibraryStackedThumbnail({
  asset,
  isHovered = false,
  autoPlayVideo = false,
  onLoadError,
}: AssetLibraryStackedThumbnailProps) {
  return (
    <div className="relative h-full w-full">
      {Array.from({ length: STACK_LAYER_COUNT }, (_, index) => (
        <div
          key={index}
          aria-hidden
          className={STACK_LAYER_CLASS}
          style={{
            left: `${(index + 1) * STACK_OFFSET_PX}px`,
            zIndex: 49 - index,
          }}
        >
          <AssetLibraryThumbnail
            assetType={asset.assetType}
            thumbnailURL={asset.thumbnailURL}
          />
        </div>
      ))}

      <div className="relative z-50 h-full w-full overflow-hidden rounded-lg border-r-2 border-r-white dark:border-r-gray-90">
        <AssetLibraryThumbnail
          assetType={asset.assetType}
          thumbnailURL={asset.thumbnailURL}
          isHovered={isHovered}
          autoPlayVideo={autoPlayVideo}
          onLoadError={onLoadError}
        />
      </div>
    </div>
  );
}
